import axios from "axios";
import { HEADERS } from "../../UrlAndPaths";
import store from "../../../Redux/store";
import { get_shift } from "../../../Redux/Settings/Shift/viewShiftSlice";
import { get_employeelist_by_branch, update_shift_status } from "../../../Redux/Settings/Shift/shiftStatusSlice";
import db from "../../../offline/db";

//View all shift API Call
export const viewShiftAPICall = async (body) => {

  await axios
    .post("settings/viewshifts",body, HEADERS)

    .then((res) => {
      if (res.status === 200) {
        store.dispatch(get_shift(res.data ));
      }
    })
    .catch((err) => {
      store.dispatch(get_shift( undefined ));
      console.log(err.response);
    });
};

//Know shift status
//body eg-- { "branchId":"TESPA1"}
export const getShiftStatusAPICAll = async (body) => {
  await axios.post("settings/viewactiveshift", body, HEADERS).then((res)=>{
    if(res.status===200)
    {
      // Check if response has actual shift data
      if (res.data && Object.keys(res.data).length > 0) {
        store.dispatch(update_shift_status({shiftStatus:res.data}))
        localStorage.setItem('shiftStatus',JSON.stringify(res.data))
      } else {
        // No active shift - clear localStorage
        console.log('⚠️ No active shift found, clearing localStorage');
        store.dispatch(update_shift_status({shiftStatus:undefined}))
        localStorage.removeItem('shiftStatus')
      }
    } 
  }).catch((err)=>{
      // Error or 404 - clear stale shift status
      console.log('⚠️ Error fetching shift status, clearing localStorage:', err.response?.status);
      store.dispatch(update_shift_status({shiftStatus:undefined}))
      localStorage.removeItem('shiftStatus')
      console.error(err.response);
  });
};

//Add Shift 
export const addShiftAPICall=async (body,setSuccess,setError,setSnackMsg,closeDialog)=>{
  await axios.post('settings/addshift',body,HEADERS).then((res)=>{
    if(res.status===200)
    {
        setSnackMsg('Shift added 👍')
        setSuccess(true)
        // closeDialog(false)
    }
  }).catch((err)=>{
    if(err.response.status === 500){
      setSnackMsg('Internal Server error !')
    }
    else{
      setSnackMsg(err?.response?.data)
    }
    setError(true)
    console.error(err.response);
  })
}


///  View employee by branch in add manual shift
export const viewEmployeeByBranchInShift=(body)=>{
  axios.post('settings/viewshiftsettingsbyid',body,HEADERS)
  .then((res)=>{
    if(res.status===200){
       store.dispatch(get_employeelist_by_branch({empoloyeeBranchData:res.data}))
    }
  })
  .catch((err)=>{
    store.dispatch(get_employeelist_by_branch({empoloyeeBranchData:undefined}))
    
  })
}

/**
 * Check if there's a pending shift end for a branch
 * Used to show "Shift End Pending" status in UI
 */
export const checkPendingShiftEnd = async (branchId) => {
  try {
    const pendingShiftEnd = await db.getPendingShiftEndForBranch(branchId);
    const localStatus = await db.getLocalShiftStatus(branchId);
    
    if (pendingShiftEnd || localStatus?.status === 'PENDING_END') {
      return {
        hasPending: true,
        shiftId: pendingShiftEnd?.shiftId || localStatus?.shiftData?.shiftId,
        queuedAt: pendingShiftEnd?.timestamp || localStatus?.timestamp,
        status: 'PENDING_END'
      };
    }
    
    return { hasPending: false };
  } catch (error) {
    console.error('Error checking pending shift end:', error);
    return { hasPending: false };
  }
};

/**
 * Get shift status with offline awareness
 * Checks both server and local pending status
 */
export const getShiftStatusWithOfflineCheck = async (body) => {
  const branchId = body.branchId;
  
  // First check for pending shift end
  const pendingCheck = await checkPendingShiftEnd(branchId);
  
  if (pendingCheck.hasPending) {
    console.log('⚠️ Pending shift end found, returning PENDING_END status');
    // Return a special status indicating shift end is pending
    store.dispatch(update_shift_status({
      shiftStatus: {
        status: 'PENDING_END',
        pendingShiftEnd: true,
        shiftId: pendingCheck.shiftId,
        queuedAt: pendingCheck.queuedAt
      }
    }));
    localStorage.setItem('shiftStatus', 'PENDING_END');
    return { pendingShiftEnd: true };
  }
  
  // No pending shift end, proceed with normal API call
  await getShiftStatusAPICAll(body);
  return { pendingShiftEnd: false };
};

